// components/Seo.js
import { useEffect } from 'react';
import { translations } from '../utils/translations';

export const Seo = ({ language = 'en' }) => {
  useEffect(() => {
    console.log('SEO Component: Language changed to', language);
    
    const t = translations[language]?.seo || translations.en.seo;
    
    // Default ke home page untuk sekarang
    const title = t.titles.home;
    const description = t.descriptions.home;
    const keywords = t.keywords;

    console.log('Updating SEO with:', { title, description, language });

    // Update document title
    document.title = title;

    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;

    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = keywords;

    // Update html lang attribute
    document.documentElement.lang = language;

    // Update Open Graph tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:site_name', 'Triarani');
    updateMetaTag('og:locale', language === 'id' ? 'id_ID' : 'en_US');

    // Update Twitter tags
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:card', 'summary_large_image');

  }, [language]);

  // Helper function untuk update meta tags
  const updateMetaTag = (property, content) => {
    let metaTag = document.querySelector(`meta[property="${property}"]`);
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('property', property);
      document.head.appendChild(metaTag);
    }
    metaTag.setAttribute('content', content);
  };

  return null;
};